export const REQUEST = 'sitePortfolio/REQUEST';
export const FAILURE = 'sitePortfolio/FAILURE';

export const GET_PORFOLIO_IMAGES_SUCCESS = 'sitePortfolio/GET_PORFOLIO_IMAGES_SUCCESS';
export const UPLOAD_IMAGE_SUCCESS = 'sitePortfolio/UPLOAD_IMAGE_SUCCESS';
export const DELETE_IMAGE_SUCCESS = 'sitePortfolio/DELETE_IMAGE_SUCCESS';